<template>
  <!--<v-container>  &lt;!&ndash; uso de clases css class="componente-nombreClase"&ndash;&gt;
    &lt;!&ndash; inicio de NavBar Large &ndash;&gt;
    <v-row class="NavBar-large" no-gutters>
      <v-col cols="12" class="NavBar-container pa-0">
        <v-toolbar color="#1460AA" class="d-none d-sm-flex NavBar-toolBarContent">
            &lt;!&ndash; inicio de Logo/Home &ndash;&gt;
            <v-toolbar-title class="NavBar-title"><img src="../assets/logo-blanco.png" alt=""></v-toolbar-title>
            &lt;!&ndash; fin de Logo/Home &ndash;&gt;

            &lt;!&ndash; inicio de Botones &ndash;&gt;
            <v-toolbar-items class="NavBar-itemsContainer">
              <v-btn text class="NavBar-button smartbell-buttonCorrection NavBar-itemButton"
                     @click='openComponent("Home")'
                     v-if="userData.onboarding == true">Inicio</v-btn>
              <v-btn text class="NavBar-button smartbell-buttonCorrection NavBar-itemButton NavBar-userConfigurationMenuCows"
                     @click='openComponent("DashCow")'
                     v-if="userData.onboarding == true">
                <v-menu offset-y v-model="cowMenuOpen">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">Vacas</span>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title class="NavBar-listItemUserOptionsTitle">Vacas</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="NavBar-listItemUserOptionsTitle">Vaquillas</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="NavBar-listItemUserOptionsTitle">Toros</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-btn>
              <v-btn text
                     class="NavBar-button smartbell-buttonCorrection NavBar-itemButton"
                     @click='openComponent("DashGroup")'
                     v-if="userData.onboarding == true">Grupos
              </v-btn>
              <v-btn text
                     class="NavBar-button smartbell-buttonCorrection NavBar-itemButton"
                     @click='openComponent("History")'
                     v-if="userData.onboarding == true">Historial
              </v-btn>
              <v-btn text class="NavBar-button smartbell-buttonCorrection NavBar-itemButton"
                     @click='openComponent("DashResume")'
                     v-if="userData.onboarding == true">Reportes
              </v-btn>
            </v-toolbar-items>
            &lt;!&ndash; fin de Botones &ndash;&gt;

            &lt;!&ndash; inicio de Iconos izquierda &ndash;&gt;
            <v-toolbar-items class="NavBar-userItemsContainer">

                &lt;!&ndash; inicio de Campana &ndash;&gt;
                <v-badge right overlap color="#FF006A" class="NavBar-badge">
                  <template v-slot:badge>
                    <span>2</span>
                  </template>
                  <img src="../assets/bell_notification.png" alt="">
                </v-badge>
                &lt;!&ndash; fin de Campana &ndash;&gt;

                &lt;!&ndash; inicio de Nombre de Usuario &ndash;&gt;
                <span class="NavBar-name">{{userData.firstName}} {{userData.lastName}}</span>
                &lt;!&ndash; fin de Nombre de Usuario &ndash;&gt;

                &lt;!&ndash; inicio de Dropdown &ndash;&gt;
                 <v-menu
                    v-model="userMenuOpen"
                    :offset-y="true"

                    class="NavBar-userConfigurationMenu"
                    >
                    <template v-slot:activator="{ on }">
                      <v-btn class="mx-2" fab small tile outlined color="#1460AA">
                        <img src="../assets/User.png" alt="" v-on="on">
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in userMenuItems"
                        :key="index" @click='openComponent(item.components)' class="NavBar-listItemUserOptions">
                        <v-list-item-title class="NavBar-listItemUserOptionsTitle">{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                &lt;!&ndash; fin de Dropdown &ndash;&gt;

                &lt;!&ndash; inicio de LogOut &ndash;&gt;
                <span class="NavBar-logout" @click="signOut()"><img src="../assets/logout.png" alt=""></span>
                &lt;!&ndash; fin de LogOut &ndash;&gt;
            </v-toolbar-items>
            &lt;!&ndash; fin de Iconos izquierda &ndash;&gt;
        </v-toolbar>
      </v-col>
    </v-row>
    &lt;!&ndash; fin de NavBar Large &ndash;&gt;

    &lt;!&ndash; inicio de NavBar Small &ndash;&gt;
    <v-row class="d-flex" no-gutters>
      <v-col class="d-flex pa-0">
        <v-toolbar color="#1460AA" class="d-sm-none NavBar-toolBarContent pa-0">
            &lt;!&ndash; inicio de Home &ndash;&gt;
            <v-toolbar-title class="d-flex NavBar-Home align-center justify-center">
                <v-btn text @click='openComponent("Home")' v-if="userData.onboarding == true">
                    <img src="../assets/Icon_Bell_Home.svg" alt="">
                  </v-btn>
              </v-toolbar-title>
            &lt;!&ndash; fin de Home &ndash;&gt;
            <v-toolbar-items class="d-flex NavBar-Small-userItemsContainer align-center justify-center">

                &lt;!&ndash; inicio de Nombre de Usuario &ndash;&gt;
                <span class="d-flex NavBar-Small-name align-center justify-center">
                        {{userData.firstName}} {{userData.lastName}}</span>
                &lt;!&ndash; fin de Nombre de Usuario &ndash;&gt;

                &lt;!&ndash; inicio de Menu/Foto de Usuario &ndash;&gt;
                <v-badge right overlap color="#FF006A"
                         class="d-flex NavBar-badge align-end justify-end">
                    &lt;!&ndash; inicio de Notificacion &ndash;&gt;
                    <template v-slot:badge>
                      <span>2</span>
                    </template>
                    &lt;!&ndash; fin de Notificacion &ndash;&gt;
                  <v-menu
                  v-model="userMenuOpen"
                  :offset-y="true"

                  class="NavBar-userConfigurationMenu"
                  >
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab small tile outlined color="#1460AA">
                      <img class="NavBar-Small-badge-size" src="../assets/Icon_Avatar_Mobile.svg" alt="" v-on="on">
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in userMenuItems"
                      :key="index" @click='openComponent(item.components)' class="NavBar-listItemUserOptions">
                      <v-list-item-title class="NavBar-listItemUserOptionsTitle">{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                  </v-menu>
                </v-badge>
                &lt;!&ndash; fin de Menu/Foto de Usuario &ndash;&gt;
            </v-toolbar-items>
        </v-toolbar>
      </v-col>
    </v-row>
    &lt;!&ndash; fin de NavBar Small &ndash;&gt;

    &lt;!&ndash; inicio de Bottom NavBar Small &ndash;&gt;
    <div class="NavBar-small" no-gutters>
      <v-bottom-navigation class="d-sm-none align-center justify-center"
                           value="activeBtn"
                           color="white" grow
                           height="64"
                           hide-on-scroll
                           background-color="#1460AA">
                
        &lt;!&ndash; inicio de boton Vacas &ndash;&gt;
        <v-btn class="NavBar-Icon-Container mx-1">
          <span class="mt-2 std-text-xxs">VACAS</span>
          <img class="NavBar-Icon-Container" color="purple" src="../assets/Icon_BN_Cow.svg" alt="#"/>
        </v-btn>
        &lt;!&ndash; fin de boton Vacas &ndash;&gt;

        &lt;!&ndash; inicio de boton Vacas &ndash;&gt;
        <v-btn class="NavBar-Icon-Container mx-1">
          <span class="mt-2 std-text-xxs">GRUPOS</span>
          <img class="NavBar-Icon-Container" color="purple" src="../assets/Icon_BN_Stall.svg" alt="#"/>
        </v-btn>
        &lt;!&ndash; fin de boton Vacas &ndash;&gt;

        &lt;!&ndash; inicio de boton Vacas &ndash;&gt;
        <v-btn class="NavBar-Icon-Container mx-1">
          <span class="mt-2 std-text-xxs">HISTORIAL</span>
          <img class="NavBar-Icon-Container" color="purple" src="../assets/Icon_BN_History.svg" alt="#"/>
        </v-btn>
        &lt;!&ndash; fin de boton Vacas &ndash;&gt;

        &lt;!&ndash; inicio de boton Vacas &ndash;&gt;
        <v-btn class="NavBar-Icon-Container mx-1">
          <span class="mt-2 std-text-xxs">REPORTES</span>
          <img class="NavBar-Icon-Container" color="purple" src="../assets/Icon_BN_Reports.svg" alt="#"/>
        </v-btn>
        &lt;!&ndash; fin de boton Vacas &ndash;&gt;

        &lt;!&ndash; inicio de boton Vacas &ndash;&gt;
        <v-btn class="NavBar-Icon-Container mx-1">
          <span class="mt-2 std-text-xxs">ALERTAS</span>
          <img class="NavBar-Icon-Container" color="purple" src="../assets/Icon_BN_Alerts.svg" alt="#"/>
        </v-btn>
        &lt;!&ndash; fin de boton Vacas &ndash;&gt;

      </v-bottom-navigation>
    </div>
    &lt;!&ndash; fin de Bottom NavBar Small &ndash;&gt;
  </v-container>-->
  <div>
    <v-app-bar app elevation="5"
               color="#1460AA">
      <v-row no-gutters class="full-height">
        <v-col cols="2"
               class="d-flex align-center justify-start">
          <div class="ml-4">
            <v-img src="../assets/smartbell_logo.png"
                   contain
                   height="48px">
            </v-img>
          </div>
        </v-col>
        <v-col cols="7"
               class="d-flex justify-start std-text-white-1 std-text-md font-weight-bold unselectable">
          <div class="col-2 pa-0 d-flex align-center justify-center std-pointer"
               @click="openComponent('Home')"
               v-ripple>Inicio</div>
          <div class="col-2 pa-0 d-flex align-center justify-center std-pointer"
               @click="openComponent('DashCow')"
               v-ripple>Animales</div>
          <div class="col-2 pa-0 d-flex align-center justify-center std-pointer"
               @click="openComponent('DashGroup')"
               v-ripple>Grupos</div>
          <div class="col-2 pa-0 d-flex align-center justify-center std-pointer"
               @click="openComponent('History')"
               v-ripple>Historial</div>
          <div class="col-2 pa-0 d-flex align-center justify-center std-pointer"
               @click="openComponent('DashResume')"
               v-ripple>Reportes</div>
        </v-col>
        <v-col cols="3"
               class="d-flex flex-wrap">
          <div class="col-2 pa-0 d-flex justify-center align-center">
            <div class="col-12 pa-0 d-flex align-center justify-center full-height">
              <v-badge content="2"
                       offset-x="10"
                       color="#EB004E"
                       offset-y="20"
                       value="2">
                <v-img src="../assets/bell_notification.png"
                       height="36px"
                       contain>
                </v-img>
              </v-badge>
            </div>
          </div>
          <div class="col-6 pa-0 d-flex justify-center align-center white--text font-weight-medium unselectable">
            JuanJo González
          </div>
          <div class="col-2 pa-0 d-flex justify-center align-center">
            <v-menu offset-y>
              <template v-slot:activator="{on, attrs}">
                <v-avatar v-on="on">
                  <img
                      src="https://cdn.vuetifyjs.com/images/john.jpg"
                      alt="John">
                </v-avatar>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in userMenuItems" :key="index" @click='openComponent(item.components)'>
                  <v-list-item-title>{{item.title}}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="col-2 pa-0 d-flex justify-center align-center">
            <div @click="signOut()">
              <v-img src="../assets/logout.png"
                     contain
                     height="30px">
            </v-img>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
    data () {
      return {
        dialog: false,
        userMenuOpen: false,
        userMenuItems: [
          {
            title: 'Configurar mi perfil',
            components: 'UserProfile'
          },
          {
            title: 'Configurar mi rancho',
            components: 'RanchConfiguration'
          },
          // { title: 'Mensajes Recibidos'},
          {
            title: 'Administrar usuarios',
            components: 'UserAdministration'
          },
          {
            title: 'Cambiar Plan',
            components: 'UserType'
          },
        ],
        showMenu: false,
        cowMenuOpen: false
      }
  },
  components: {
  },
  computed: {
    userData(){
      return this.$store.getters.getUserData
    }
  },
  methods: {
    openComponent(component) {
      if (this.$route.name !== component) {
        this.$router.push({name: component});
      }
    },
    signOut() {
        this.$store.dispatch('signOut');
    }
  }
};
</script>

<style lang="css">
  @import '../style/NavBar.css';
</style>
